export { Add } from './extensions/add';
export { Plus } from './plus';
export { AddDocument } from './add-document';
export { AddFolder } from './add-folder';
export { LinearAddIcon } from './linear-add';
export { Alert } from './alert';
export { ArrowBack } from './arrow-back';
export { ArrowDropDown } from './arrow-drop-down';
export { AddPerson } from './add-person';
export { ArrowRight } from './arrow-right';
export { ArrowRight2 } from './arrow-right-2';
export { ArrowRight3 } from './arrow-right-3';
export { ArrowRightCircle } from './arrow-right-circle';
export { ArrowLeft } from './arrow-left';
export { ArrowLeft2 } from './arrow-left2';
export { Attachment } from './attachment';
export { AvisaLogo } from './avisa-logo';
export { AvisaLogoColored } from './avisa-logo-colored';
export { Bell } from './bell';
export { BrokenImage } from './broken-image';
export { Calendar } from './calendar';
export { Camera } from './camera';
export { Card } from './card';
export { CautionCircleOutlined } from './caution-circle-outlined';
export { Checkbox } from './checkbox';
export { CheckboxIndeterminate } from './checkbox-indeterminate';
export { CheckedCheckbox } from './checked-checkbox';
export { CheckedRadioButton } from './checked-radio-button';
export { Check } from './check';
export { CloudSun } from './cloud-sun';
export { Clear } from './clear';
export { Clock } from './clock';
export { Clock2 } from './clock2';
export { Close } from './close';
export { CloseX } from './close-x';
export { Crumbs } from './crumbs';
export { Delete } from './delete';
export { DoubleCheck } from './double-check';
export { Download } from './download';
export { DynamicCloudLogo } from './dynamic-cloud-logo';
export { Earth } from './earth';
export { FilledClose } from './filled-close';
export { FingerPrint } from './fingerprint';
export { LightClose } from './light-close';
export { Cloud } from './cloud';
export { Comments } from './comments';
export { Dashboard } from './dashboard';
export { DefaultAvatar } from './default-avatar';
export { DeviceUnknown } from './device-unknown';
export { Documents } from './documents';
export { Email } from './email';
export { Edit } from './edit';
export { File } from './file';
export { FileCheck } from './file-check';
export { FileEdit } from './file-edit';
export { Folder } from './folder';
export { Forward } from './forward';
export { Hamburger } from './hamburger';
export { HamburgerSmall } from './hamburger-small';
export { Halcyon } from './halcyon';
export { History } from './history';
export { Image } from './image';
export { Key } from './key';
export { Link } from './link';
export { Location } from './location';
export { Logout } from './logout';
export { Meeting } from './meeting';
export { MenuDots } from './menu-dots';
export { Message } from './message';
export { Notification } from './notification';
export { OCALogo } from './o-c-a-logo';
export { OCALogoColored } from './o-c-a-colored-logo';
export { PencilRuler } from './pencil-ruler';
export { Pencil } from './pencil';
export { PersonDelete } from './person-delete';
export { Person } from './person';
export { Print } from './print';
export { RadioButton } from './radio-button';
export { Refresh } from './refresh';
export { Send } from './send';
export { Share } from './share';
export { StarDefault } from './star-default';
export { StarChecked } from './star-checked';
export { Search } from './search';
export { Transfer } from './transfer';
export { TripleDotsHorizontal } from './triple-dots-horizontal';
export { UnwrapFolder } from './unwrap-folder';
export { Upload } from './upload';
export { Weather } from './weather';
export { Error } from './error';
export { Info } from './info';
export { Exit } from './exit';
export { Cup } from './cup';
export { Work } from './work';
export { Task } from './task';
export { Timer } from './timer';
export { Motaded } from './motaded';
export { TimeClock } from './time-clock';
export { Ugicon } from './ugicon';
export { Umbrella } from './umbrella';
export { Wind } from './wind';
export { VideoCamera2 } from './video-camera-2';
export { TimeCircle } from './time-circle';
export { CalendarEdit } from './calendar-edit';
export { Attach } from './attach';
export { MultipleUsers } from './multiple-users';
export { Paper } from './paper';
export { Tasks } from './tasks';
export { PersonalCard } from './personal-card';
export { Loading } from './loading';
export { LoadingCircle } from './loading-circle';
export { CheckBadge } from './check-badge';
export { SearchScan } from './search-scan';
export { ClockDash } from './clock-dash';
export { Target } from './target';
export { CalendarBold } from './calendar-bold';
export { GridInterface } from './grid-interface';
export { WorldNetwork } from './world-network';
export { TargetBold } from './target-bold';
export { VideoCameraBold } from './video-camera-bold';
export { HrBold } from './hr-bold';
export { DocumentBold } from './document-bold';
export { RecordFlow as RecordFlowIcon } from './record-flow';
export { LocationBold } from './location-bold';
export { AddUser } from './add-user';
export { UsersChecked } from './users-checked';
export { Comment } from './comment';
export { Export } from './export';
export { WarningCircle } from './warning-circle';
export { MultiUserStroke } from './multi-user-stroke';
export { LeftArrowRounded } from './left-arrow-rounded';
export { RightArrowRounded } from './right-arrow-rounded';
export { UpArrowRounded } from './up-arrow-rounded';
export { DownArrowRounded } from './down-arrow-rounded';
export { DefaultUser } from './default-user';
export { DefaultTask } from './default-task';
export { DefaultProject } from './default-project';

// FILE EXTENSTONS ICONS
export { Aiff } from './extensions/aiff';
export { Avi } from './extensions/avi';
export { Bmp } from './extensions/bmp';
export { Cad } from './extensions/cad';
export { Csv } from './extensions/csv';
export { Jpg } from './extensions/jpg';
export { Dbf } from './extensions/dbf';
export { Dng } from './extensions/dng';
export { Doc } from './extensions/doc';
export { Eps } from './extensions/eps';
export { Flac } from './extensions/flac';
export { Flv } from './extensions/flv';
export { Html } from './extensions/html';
export { Gif } from './extensions/gif';
export { Mov } from './extensions/mov';
export { Mp3 } from './extensions/mp3';
export { Mp4 } from './extensions/mp4';
export { Mxf } from './extensions/mxf';
export { Pdf } from './extensions/pdf';
export { Png } from './extensions/png';
export { Ppt } from './extensions/ppt';
export { Svg } from './extensions/svg';
export { Xls } from './extensions/xls';
export { Rar } from './extensions/rar';
export { Tab } from './extensions/tab';
export { Tiff } from './extensions/tiff';
export { Txt } from './extensions/txt';
export { Xml } from './extensions/xml';
export { Zip } from './extensions/zip';
export { Wav } from './extensions/wav';
export { UnknownFile } from './unknown-file';
